import { StateUtils } from '@spartacus/core';
import { SoldTo } from '../../../../core/model/user.model';
import { SoldToActions } from '../actions/index';
import { ActiveSoldToActionTypes } from '../actions/sold-to-active.action';

export const initialState: SoldTo = <SoldTo>{};

export function reducer(
  state: SoldTo = initialState,
  action: SoldToActions.ActiveSoldToActions | StateUtils.LoaderAction
): SoldTo {
  switch (action.type) {
    case ActiveSoldToActionTypes.ClearActiveSoldTo:
    case ActiveSoldToActionTypes.LoadActiveSoldToFail: {
      return initialState;
    }
    case ActiveSoldToActionTypes.LoadActiveSoldToSuccess: {
      return action.payload ? action.payload : initialState;
    }
  }

  return state;
}
